<script>
/**
 * ****************************************************************************
 * @description     :   Input Search Component
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Best Security
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import _ from 'lodash-uuid';
import { mapMutations, mapState } from 'vuex';

import SamplePopupSearch from '@/views/popupSearch/samplePopupSearch';
import bm004000i_customer from '@/views/popupSearch/bm004000i-customer';
import bm004000i_tantou from '@/views/popupSearch/bm004000i-tantou';
import bb001000l_customer from '@/views/popupSearch/bb001000l-customer';
import bb001000l_location from '@/views/popupSearch/bb001000l-location';
import bb001000l_sales from '@/views/popupSearch/bb001000l-sales';
import ba001000l_customer from '@/views/popupSearch/ba001000l-customer';
import ba001000l_location from '@/views/popupSearch/ba001000l-location';
import ba001000l_daily from '@/views/popupSearch/ba001000l-daily';
import bf005000u_employee from '@/views/popupSearch/bf005000u-employee';
import be001000i_closedate from '@/views/popupSearch/be001000i-closedate';
import be001000i_payment from '@/views/popupSearch/be001000i-payment';
import ba001000i_calculate from '@/views/popupSearch/ba001000i-calculate';
import bh001000i_user from '@/views/popupSearch/bh001000i-user';
import bh002000i_product from '@/views/popupSearch/bh002000i-product';
import bh002100i_product from '@/views/popupSearch/bh002100i-product';
import bh002000i_user from '@/views/popupSearch/bh002000i-user';
import bf002000i_location from '@/views/popupSearch/bf002000i-location';
import bh002100i_user from '@/views/popupSearch/bh002100i-user';

/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of input search component
 */
var BsInputSearch = {
    template: template,
    components: {
        SamplePopupSearch,
        bm004000i_customer,
        bm004000i_tantou,
        bb001000l_customer,
        bb001000l_location,
        bb001000l_sales,
        ba001000l_customer,
        ba001000l_location,
        ba001000l_daily,
        bf005000u_employee,
        be001000i_closedate,
        be001000i_payment,
        ba001000i_calculate,
        bh001000i_user,
        bh002000i_product,
        bh002100i_product,
        bh002000i_user,
        bf002000i_location,
        bh002100i_user
    },
    props: {
        id: String,
        label: String,
        index: String | Number,
        index2: Object,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        buttonClass: String,
        buttonId: String,
        isDisabledInput: {
            type: Boolean,
            default: false
        },
        isHidden: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default: 'fas fa-search'
        },
        isShowClear: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: '参照して下さい'
        },
        value: String,
        modelValue: Object,
        initData: Object,
        pageSearch: String,
        propertyForId: String,
        propertyForName: String,
        popupName: String,
        isRequired: Boolean,
        isReadonly: {
            type: Boolean,
            default: true
        },
        isShowLabel: {
            type: Boolean,
            default: false
        },
        isShowFooter: {
            type: Boolean,
            default: false
        },
        isModalHeader: {
            type: Boolean,
            default: true
        },
        isDisabled: Boolean,
        isDisabledClear: Boolean,
        onChange: Function,
        onChangeInput: Function,
        size: String,
        maxLength: Number
    },
    emits: ['update:modelValue'],
    data() {
        return {
            newId: '',
            show: true,
            popup: ''
        };
    },
    mounted() {
        if (this.id && this.id != '') {
            this.newId = this.id;
        } else {
            this.newId = _.uuid();
        }
        const vm = this;
        let countLoop = 0;
        const interval = setInterval(function () {
            if (vm.$refs['popupSearch_' + vm.newId]) {
                vm.$refs['popupSearch_' + vm.newId].addEventListener(
                    'hidden.bs.modal',
                    vm.hidePopup
                );
                vm.$refs['popupSearch_' + vm.newId].addEventListener(
                    'show.bs.modal',
                    vm.showPopup
                );
                clearInterval(interval);
                // console.log(this.pageSearch, countLoop, 'added event');
            }
            if (countLoop > 100) {
                clearInterval(interval);
                // console.log('cannot add event');
            }
            countLoop++;
        }, 100);
    },
    unmounted() {
        this.hidePopup();
    },
    computed: {
        ...mapState('app', ['footerModals']),
        lengthFooterModals() {
            return this.footerModals.length;
        },
        ...mapMutations('app', ['hideHeaderError']),
        vewValue() {
            if (this.modelValue && this.modelValue[this.propertyName]) {
                return this.modelValue[this.propertyName];
            }
            return '';
        },
        propertyId() {
            if (this.propertyForId) {
                return this.propertyForId;
            }
            return 'code';
        },
        propertyName() {
            if (this.propertyForName) {
                return this.propertyForName;
            }
            return 'name';
        },
        modalTitle() {
            this.show = true;
            if (this.popupName) {
                return this.popupName;
            }
            /*eslint indent: [2, 4, {"SwitchCase": 1}]*/
            switch (this.pageSearch) {
                case 'bm004000i_customer':
                    return '検索画面';
                case 'bm004000i_tantou':
                    return '検索画面';
                case 'bb001000l_customer':
                    return '検索画面';
                case 'bb001000l_location':
                    return '検索画面';
                case 'bb001000l_sales':
                    return '検索条件';
                case 'ba001000l_customer':
                    return '検索画面';
                case 'ba001000l_location':
                    return '検索画面';
                case 'ba001000l_daily':
                    return '日報作成';
                case 'bf005000u_employee':
                    return '検索条件';
                case 'be001000i_closedate':
                    return '請求締日選択';
                case 'be001000i_payment':
                    return '検索画面';
                case 'ba001000i_calculate':
                    return '日報再計算処理';
                case 'bh001000i_user':
                    return '検索画面';
                case 'bh002000i_product':
                    return '検索画面';
                case 'bh002100i_product':
                    return '検索画面';
                case 'bh002000i_user':
                    return '検索画面';
                case 'bh002100i_user':
                    return '検索画面';
                default:
                    return '検索画面';
                case 'bf002000i_location':
                    return '検索画面';
            }
        },
        realMaxLength() {
            return this.maxLength;
        }
    },
    methods: {
        // ...mapActions('app', ['hideHeaderError']),
        /**
         * update value for input search
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        updateInput(item) {
            if (this.onChange) {
                this.onChange(this.index, this.modelValue, item);
            } else {
                this.$emit('update:modelValue', item);
            }
        },
        /**
         * remove value for input search
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        clearInput() {
            if (this.onChange) {
                this.onChange(this.index2, this.modelValue, null);
            } else {
                this.$emit('update:modelValue', null);
            }
        },
        hidePopup() {
            this.show = false;
            if (this.hideHeaderError) {
                this.hideHeaderError();
            }
            const els = document.getElementsByClassName('datalist-top');
            const length = els.length;
            for (let i = 0; i < length; i++) {
                els[i].style.paddingRight = null;
            }
        },
        showPopup() {
            this.popup = this.pageSearch;
            this.show = true;
            if (this.hideHeaderError) {
                this.hideHeaderError();
            }
            const paddingRight = window.innerWidth - document.body.clientWidth;
            if (paddingRight > 0) {
                const els = document.getElementsByClassName('datalist-top');
                const length = els.length;
                for (let i = 0; i < length; i++) {
                    els[i].style.paddingRight = paddingRight + 'px';
                }
            }
        },
        changeInput(e) {
            if (this.onChangeInput) {
                this.onChangeInput(this.index, e.target.value);
            }
        },
        /**
         * get max lenght input
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        getRealMaxLength() {
            // let maxl = this.maxLength;
            // if (maxl == undefined || maxl == null) {
            //     switch (this.pageSearch) {
            //         case 'ra001800v':
            //             maxl = 100;
            //             break;
            //         case 'ra001900v':
            //             maxl = 200;
            //             break;
            //         default:
            //             maxl = 50;
            //     }
            // }
            return undefined;
        },
        onclickFooterButton(callback) {
            if (callback) {
                callback();
            }
            this.$refs['btnClose_' + this.newId]?.click();
        }
    }
};
export default BsInputSearch;
</script>
